import { Component, ChangeDetectionStrategy , inject} from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ConfiguracionGlobalService } from '@/app/services/configuracion-global.service';
import { TokenReaderService } from '@/app/services/security/token-reader.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-cuenta-credito',
    templateUrl: './cuenta-credito.component.html',
    styleUrls: ['./cuenta-credito.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CuentaCreditoComponent {
  private spinner = inject(NgxSpinnerService);

  configGlobalRQ = {
    idConfiguracionGlobal: "",
    nombre: "",
    valor: "", 
    modificadoPor: "",
    fechaModificacion: new Date(),
  }

  
  //validaciones
  hasFinished: boolean = false;


  constructor(
    private toastr: ToastrService,
    private router: Router,
    private userTokenReader: TokenReaderService,
    public dialogRef: MatDialogRef<CuentaCreditoComponent>,
    private configuracionGlobalService: ConfiguracionGlobalService,
  ){
    this.getConfiguracionGlobal();
  }


  getConfiguracionGlobal(){
    this.spinner.show();

    this.configuracionGlobalService.getConfiguracionGlobal().subscribe({
      next: (data: any)=>{
        if(data != null && data.ConfiguracionGlobal != null && data.ConfiguracionGlobal.length > 0){
          let info = data.ConfiguracionGlobal[0];

          this.configGlobalRQ.valor = info['Valor'];
          this.configGlobalRQ.idConfiguracionGlobal = info['idConfiguracionGlobal'];
          this.configGlobalRQ.nombre = info['Nombre'];
        }else{
          this.configGlobalRQ.idConfiguracionGlobal = "0";
        }
        this.spinner.hide();
      },
      error: (err) =>{
        this.spinner.hide();
        
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
          this.toastr.error(ClassInfo.Error, 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  formSubmit(form: NgForm){
    console.log(form);
    if(form.valid){
      Swal.fire({
        title: 'Confirmar',
        text: "¿Deseas guardar la configuración global?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor:  '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true
      }).then((result) => { 
        if(result.value){
          this.insertConfigGlobal();
        }
      });
    }
  }

  insertConfigGlobal(){
    this.spinner.show();
    this.configGlobalRQ.modificadoPor = this.userTokenReader.getUserData().idUsuario;
    this.configuracionGlobalService.updateConfiguracionglobal(this.configGlobalRQ).subscribe({
      next: (data: any)=>{
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Configuración global guardado correctamente.',
          'success'
        ).then(result=>{
          this.hasFinished = true;
          this.onClose();
        });
      },
      error: (err) =>{
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  onClose(){
    if(!this.hasFinished){
      Swal.fire({
        title: 'Alerta',
        text: "No se han guardado los cambios. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.dialogRef.close({updateList: false});
        }
      });
    } else{
      this.dialogRef.close({updateList: false});
    }
  }

}
